// internal/ProValidationPage.jsx — Validation AYA Pro refondue (MÊMES APIs /api/inscription-pro/*, zéro doublon métier).
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import InternalLayout, { S, IT } from "@/internal/InternalLayout";

const API = process.env.REACT_APP_BACKEND_URL || "";
const H = () => ({ Authorization: `Bearer ${localStorage.getItem("civ_user_token") || ""}` });
const STATUS = {
  pending_validation: { l: "En attente", c: "#F59E0B" },
  validated: { l: "Validée", c: "#2EE27B" },
  rejected: { l: "Rejetée", c: "#F87171" },
};
const FILTERS = [["all", "Toutes"], ["pending_validation", "En attente"], ["validated", "Validées"], ["rejected", "Rejetées"]];

export default function ProValidationPage() {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("pending_validation");
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    const url = `${API}/api/inscription-pro/list${filter !== "all" ? `?status=${filter}` : ""}`;
    try {
      const r = await fetch(url, { headers: H() });
      const d = await r.json();
      setRows(d.ok ? d.signups || d.items || [] : []);
    } catch { setRows([]); }
  }, [filter]);
  useEffect(() => { load(); }, [load]);

  const act = async (id, kind) => {
    if (kind === "reject" && !window.confirm("Rejeter cette inscription ?")) return;
    setBusy(id);
    try {
      const r = await fetch(`${API}/api/inscription-pro/${id}/${kind}`, { method: "POST", headers: { "Content-Type": "application/json", ...H() } });
      const d = await r.json();
      if (!d.ok) throw new Error(d.error || "action_failed");
      toast.success(kind === "validate" ? "✅ Inscription validée" : "Inscription rejetée");
      fetch(`${API}/api/internal/audit`, { method: "POST", headers: { "Content-Type": "application/json", ...H() }, body: JSON.stringify({ action: `pro_${kind}`, details: { signup_id: id } }) }).catch(() => {});
      load();
    } catch (e) { toast.error(String(e.message || e)); }
    finally { setBusy(null); }
  };

  const shown = (rows || []).filter((r) => {
    const t = q.trim().toLowerCase();
    if (!t) return true;
    return JSON.stringify(r).toLowerCase().includes(t);
  });

  return (
    <InternalLayout title="Validation AYA Pro" subtitle="Opérations → AYA Pro → Validation des inscriptions · même workflow, nouveau design AYA Internal.">
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        {FILTERS.map(([v, l]) => (
          <button key={v} data-testid={`pv-filter-${v}`} onClick={() => setFilter(v)}
            style={{ padding: "7px 14px", borderRadius: 999, fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit",
              border: filter === v ? "1px solid #2EE27B" : "1px solid rgba(139,163,148,0.3)",
              background: filter === v ? "rgba(46,226,123,0.12)" : "transparent", color: filter === v ? "#2EE27B" : IT.muted }}>{l}</button>
        ))}
        <input data-testid="pv-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="🔎 Rechercher…"
          style={{ flex: 1, minWidth: 160, background: "#0D1310", border: `1px solid ${IT.border}`, borderRadius: 10, padding: "7px 12px", color: IT.text, fontSize: 12.5, outline: "none", fontFamily: "inherit" }} />
      </div>
      {rows == null && <div style={{ color: IT.muted, fontSize: 13 }}>Chargement…</div>}
      {rows != null && shown.length === 0 && <div style={{ ...S.card, padding: 18, color: IT.muted, fontSize: 13 }} data-testid="pv-empty">Aucune inscription dans ce filtre.</div>}
      <div style={{ display: "flex", flexDirection: "column", gap: 9 }} data-testid="pv-list">
        {shown.map((r) => {
          const st = STATUS[r.status] || { l: r.status, c: IT.muted };
          return (
            <div key={r.id || r._id} data-testid={`pv-row-${r.id || r._id}`} style={{ ...S.card, padding: "13px 15px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                <span style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(46,226,123,0.1)", border: "1px solid rgba(46,226,123,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15 }}>🏪</span>
                <span style={{ flex: 1, minWidth: 160 }}>
                  <span style={{ display: "block", fontSize: 13.5, fontWeight: 800 }}>{r.business_name || r.name || r.display_name || "Sans nom"}</span>
                  <span style={{ fontSize: 11, color: IT.muted }}>
                    {[r.category || r.activity_type, r.commune || r.city, r.phone].filter(Boolean).join(" · ")}
                    {r.created_at && ` · ${new Date(r.created_at).toLocaleDateString("fr-FR")}`}
                  </span>
                </span>
                <span style={{ fontSize: 10, fontWeight: 900, color: st.c, border: `1px solid ${st.c}55`, borderRadius: 999, padding: "3px 10px" }}>{st.l}</span>
                {r.status === "pending_validation" && (
                  <span style={{ display: "flex", gap: 7 }}>
                    <button data-testid={`pv-validate-${r.id || r._id}`} disabled={busy === (r.id || r._id)} onClick={() => act(r.id || r._id, "validate")} style={S.btn}>✓ Valider</button>
                    <button data-testid={`pv-reject-${r.id || r._id}`} disabled={busy === (r.id || r._id)} onClick={() => act(r.id || r._id, "reject")}
                      style={{ ...S.ghost, borderColor: "rgba(248,113,113,0.4)", color: "#F87171", background: "rgba(248,113,113,0.06)" }}>✕ Rejeter</button>
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </InternalLayout>
  );
}
